import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=3a29c0c2"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=3a29c0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports